import { type } from "@/api/arktype";

import { isoDate } from "@/lib/iso-date";
import { pagination } from "@/lib/pagination";

const examFlag = type.enumerated("normal", "low", "high", "attention", "indeterminate");
const optionalText = type("string.trim").pipe((value) => (value.length === 0 ? null : value));
const optionalNumber = type("string.trim")
	.pipe((value) => (value.length === 0 ? null : Number(value.replace(",", "."))))
	.to("number | null");

const editResultForm = type({
	valueNum: optionalNumber,
	valueText: optionalText,
	unit: optionalText,
	refRangeText: optionalText,
	flag: examFlag,
}).pipe((input) => ({
	value_num: input.valueNum,
	value_text: input.valueText,
	unit: input.unit,
	ref_range_text: input.refRangeText,
	flag: input.flag,
}));

const confirm = type({
	message_id: "string > 0",
	patient_id: type("number.integer > 0 | null").default(null),
	anchor_id: type("number.integer > 0 | null").default(null),
});

const upload = type({
	patient_id: type("number.integer > 0 | null").default(null),
	person_id: type("number.integer > 0 | null").default(null),
	mime: "'application/pdf' | 'image/jpeg' | 'image/png' | 'image/webp'",
	data: "string > 0",
});

const editResult = type({
	id: "number.integer > 0",
	"value_num?": "number | null",
	"value_text?": "string | null",
	"unit?": "string | null",
	"ref_range_text?": "string | null",
	"flag?": examFlag,
}).narrow((input, ctx) => {
	const touched =
		input.value_num !== undefined ||
		input.value_text !== undefined ||
		input.unit !== undefined ||
		input.ref_range_text !== undefined ||
		input.flag !== undefined;

	if (!touched) {
		return ctx.reject({ expected: "at least one field to edit", actual: "empty" });
	}

	return true;
});

export const ExamSchemas = {
	editResultForm,
	queue: pagination,
	confirm,
	discard: type({ message_id: "string > 0" }),
	upload,
	byPatient: type({ patient_id: "number.integer > 0" }),
	editResult,
	arbitrateResult: type({ id: "number.integer > 0", model: "string > 0" }),
	arbitrateDate: type({ document_id: "number.integer > 0", collection_date: isoDate }),
	anchor: type({
		document_id: "number.integer > 0",
		patient_id: type("number.integer > 0 | null").default(null),
		anchor_id: type("number.integer > 0 | null").default(null),
		confirm_identity: type("boolean").default(false),
	}),
	confirmIdentity: type({ document_id: "number.integer > 0" }),
	reanalyze: type({ document_id: "number.integer > 0" }),
	editInterpretation: type({
		document_id: "number.integer > 0",
		text: "string > 0",
		validate: "boolean",
	}),
};
